import React from 'react'
import PropTypes from 'prop-types'

const ModelSupportConversationTitle = ({ itemUrl, itemTitle }) => (
  <div>
    Model support:
    <a href={itemUrl} className="u-ml10">{itemTitle}</a>
  </div>
)

ModelSupportConversationTitle.propTypes = {
  itemUrl: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
}

export default ModelSupportConversationTitle
